// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"368":"Changepassword","810":"registView","939":"activateView","966":"login"}[chunkId] || chunkId) + "." + {"368":"ccd9de55","610":"8596de21","810":"aa7dc0c5","939":"adcdd5b2","966":"61ca820e"}[chunkId] + ".js";
};